





















import Vue, {VueConstructor} from 'vue'
import StringField from './fields/string.vue'
import TextareaField from './fields/textarea.vue'
import SelectField from './fields/select.vue'
import BdateField from './fields/bdate.vue'
import MaskField from './fields/mask.vue'
export default Vue.extend({
  name: 'UiFormField',
  components: {
    StringField,
    SelectField,
    BdateField,
    MaskField,
    TextareaField
  },
  props: {
    value: {},
    label: String,
    error: Boolean,
    field: String,
    placeholder: String,
    hideDynPlaceholder: Boolean,
    required: Boolean,
    options: {},
    disabled: Boolean
  },
  methods: {
    onInput (event: any): any {
      this.$emit('input', event)
    },
    onFocus (event: any): any {
      this.$emit('focus', event)
    },
    onBlur (event: any): any {
      this.$emit('blur', event)
    }
  },
  computed: {
    fieldValue: {
      get (): any {
        return this.value
      },
      set (): any {
      }
    } as any,
    fieldName (): string {
      return this.field + '-field'
    },
  }
})
